




















import { Component, Emit, Vue } from 'vue-property-decorator';
import { arrayToTree } from '@/util/arrayToTree';
import { institutionServer, regionServe } from '@/api/installServer';
import { ergodicTree } from '@/util/tree';

@Component({
  components: {},
})
export default class BindArea extends Vue {
  visible = false;
  _showOnce = false;

  private areaList: any = [];
  private areaListArr: any = [];
  private checkedAreaArr: any = [];
  private deptId: any = '';

  created() {
    this.getSpaceAreaData();
    // const userInfo: any = localStorage.getItem('userInfo');
    // this.info = JSON.parse(userInfo);
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe.getRegionAllData({}).then((res: any) => {
      if (res.code === '200') {
        this.areaListArr = res.data;
        this.areaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  /**
   * 处理首次打开窗口
   */
  async handleShowOnce() {
    if (this._showOnce) return;
    // await
    this._showOnce = true;
  }

  /**
   * 打开新增窗口
   */
  showBindAreaDialog(id: any) {
    this.handleShowOnce();
    this.visible = true;
    this.deptId = id;
    this.checkedAreaArr = [];
    setTimeout(() => {
      this.getSpaceBindAreaDept();
    });
  }

  getDataList(key: any, data: any) {
    if (key === data.id) {
      this.checkedAreaArr.push(data._idPath);
      return;
    }
    if (data.children && data.children.length > 0) {
      data.children.forEach((item: any) => {
        this.getDataList(key, item);
      });
    }
  }

  getSpaceBindAreaDept() {
    ergodicTree(this.areaList);
    institutionServer.spaceBindAreaDept(this.deptId).then((res: any) => {
      if (res.code === '200') {
        res.data.forEach((item: any) => {
          this.areaList.forEach((elem: any) => {
            this.getDataList(item, elem);
          });
        });
        console.log(this.checkedAreaArr, 'this.checkedAreaArr');
      } else {
      }
    });
  }

  /**
   * 关闭窗口
   */
  hideDialog() {
    this.visible = false;
    setTimeout(() => {
      this.deptId = '';
      this.checkedAreaArr = [];
      // const obj: any = (this.$refs.elCascader as any).getCheckedNodes();
    }, 200);
  }

  /**
   * 【按钮】提交按钮点击
   */
  handleSubmitBtnClick() {
    const obj: any = (this.$refs.elCascader as any).getCheckedNodes();
    const areaIds: any = [];
    if (obj && obj.length > 0) {
      obj.forEach((item: any) => {
        areaIds.push(item.data.id);
      });
    }
    institutionServer
      .spaceBindArea({
        deptId: this.deptId,
        areaIds,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('绑定成功。');
          this.hideDialog();
          this.$emit('on-response');
        } else {
          this.$message.warning(res.msg);
        }
      });
  }
}
